import { useState as e } from "react";
const f = 0;
function v(u, r, t, n) {
  const [o, h] = e(!1), s = o ? u : r, [c, g] = e(s ? s.length : f), [C, a] = e(!1);
  return {
    valueCounter: c,
    isOnBlur: C,
    handleBlur: () => {
      a(!0), n && n();
    },
    handleChange: (l) => {
      h(!0), g(l.target.value.length), t && t(l), a(!1);
    }
  };
}
export {
  v as useInput
};
